import BaseAction from "./BaseAction";
import QrCodeReducer from "../reducers/QrCodeReducer";

class QrCodeAction extends BaseAction {
  toggle = (open) => this.dispatch({ open });
}

const action = new QrCodeAction(QrCodeReducer);

export default action;
